// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"63413988","204":"63413988","410":"63413988"}[chunkId] + ".chunk.css";
};